const membersItem = document.querySelectorAll('.members-collective-list__item');
const accountMembersInteraction = document.querySelector('.notification-bar');
const notificationBarCloseTrigger = document.querySelectorAll('.notification-bar__close-trigger');
const notificationBarSubmitTrigger = document.querySelectorAll('.notification-bar__submit-trigger');

if (membersItem.length && accountMembersInteraction) {
    [].forEach.call(membersItem, item => {
        item.querySelector('.remove').addEventListener('click', e => {
            e.preventDefault();
            accountMembersInteraction.classList.add('active');
            accountMembersInteraction.dataset.submittedFormName = item.querySelector('.remove').dataset.formName;
        })
    });
}

if (notificationBarCloseTrigger.length) {
    [].forEach.call(notificationBarCloseTrigger, closeButton => {
        closeButton.addEventListener('click', e => {
            e.preventDefault();

            closeButton.parentElement.parentElement.dataset.submittedFormName = "";
            closeButton.parentElement.parentElement.classList.remove('active');
        })
    });
}

if (notificationBarSubmitTrigger.length) {
    [].forEach.call(notificationBarSubmitTrigger, submitButton => {
        submitButton.addEventListener('click', e => {
            e.preventDefault();

            const notificationRootEl = submitButton.parentElement.parentElement;
            const remarkInput = notificationRootEl.querySelector('#remarkRemoveUser');
            const formName = notificationRootEl.dataset.submittedFormName;

            if (!formName) {
                notificationRootEl.classList.remove('active');
                return;
            }

            const form = document.forms[formName];
            if (form) {
                if (remarkInput) {
                    const input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    input.setAttribute("name", "reason");
                    input.setAttribute("value", remarkInput.value);
                    form.appendChild(input);
                    remarkInput.value = "";
                }

                form.submit();
            }

            notificationRootEl.dataset.submittedFormName = "";
            notificationRootEl.classList.remove('active');
        })
    });
}

window.addEventListener('DOMContentLoaded', (event) => {
    if (membersItem.length) {
        [].forEach.call(membersItem, item => {
            setTimeout(() => {
                item.style.animationDuration = '2s'
            }, 4000);
        });
    }
});